import { cn } from '@/utils/cn';
import type { ReactNode } from 'react';

export default function Grid({
    className = null,
    minColumns = 0,
    maxColumns = 4,
    children,
}: {
    className?: string | null;
    minColumns?: number;
    maxColumns?: number;
    children: ReactNode;
}) {
    return (
        <div
            className={cn(
                'grid w-full grid-cols-1',
                maxColumns > 1 && 'sm:grid-cols-2',
                maxColumns > 3 && 'xl:grid-cols-4',
                minColumns === 2 && 'grid-cols-2 xl:grid-cols-4',
                'gap-x-6 gap-y-4 md:gap-y-12',
                className
            )}
        >
            {children}
        </div>
    );
}
